export class Allapot {
    alias: string;
    caption: string;
    description: string;
    flags: string[];
}

export const ALLAPOT_FLAG_SZERKESZTHETO = "Szerkesztheto";
export const ALLAPOT_FLAG_SZERKESZTOMOD = "SzerkesztoMod";

export class Muvelet {
    alias: string;
    caption: string;
    description: string;
    icon: string;
    condition: string;
    toState: string;
    roles: string[];
    flags: string[];

    evaluator: Function;
    buttonclass: string;
    buttonicon: string;
    rendermode: number;
}

export const MUVELET_FLAG_LETREHOZ = "Letrehoz";
export const MUVELET_FLAG_SZERKESZTOMOD = "SzerkesztoMod";
export const MUVELET_FLAG_MENTALVERZIONELKUL = "MentAlverzioNelkul";
export const MUVELET_FLAG_MENTUJALVERZIOKENT = "MentUjAlverziokent";
export const MUVELET_FLAG_VERZIOTERVENYESIT = "VerziotErvenyesit";
export const MUVELET_FLAG_VERZIOERVENYESITESTVISSZAVON = "VerzioErvenyesitestVisszavon";
export const MUVELET_FLAG_VERZIOTERVENYTELENIT = "VerziotErvenytelenit";
export const MUVELET_FLAG_VERZIOERVENYTELENITESTVISSZAVON = "VerzioErvenytelenitestVisszavon";
export const MUVELET_FLAG_AKTIVAL = "Aktival";
export const MUVELET_FLAG_INAKTIVAL = "Inaktival";
export const MUVELET_FLAG_MEGSEMMISIT = "Megsemmisit";

export const MUVELET_FLAG_NINCSMEGJEGYZES = "NincsMegjegyzes";
export const MUVELET_FLAG_NINCSELLENORZES = "NincsEllenorzes";
export const MUVELET_FLAG_NINCSMEGEROSITES = "NincsMegerosites";
export const MUVELET_FLAG_IFORMIMPORT = "IFormImport";

export const MUVELET_FLAG_DOKUMENTUMKESZITES = "DokumentumKeszites";

export const MUVELET_FLAG_IMPORT = "Import";
export const MUVELET_FLAG_FUTTAT = "Futtat";
export const MUVELET_FLAG_KIJELOLTEK = "Kijeloltek";


// WEBPACK FOOTER //
// ./src/app/modules/universal/model/statemachine.ts